import React from 'react';
import './tour.css';
import Footer from '../footer/footer';
import {Link} from 'react-router-dom';

class Tour extends React.Component {
  render() {
    return (
      <div className="tour">
        <div className="tour__header">
          <Link style={{textDecoration: 'none'}} to="/main">
            <div className="tour__button">{'< На главную'}</div>
          </Link>
        </div>
        <Footer />
        <div className="tour__black-strip" />
        <div className="tour__footer">
          <div className="tour__footer-text">
            Виртуальный тур откроется на сайте музея в новой вкладке
          </div>
          <a
            className="link"
            href="http://virtual.rusmuseumvrm.ru/top10/pano.php?onstart=loadpano(hotspots/1.xml);st_pos(285)"
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="tour__footer-button">Экскурсия 360º</div>
          </a>
        </div>
      </div>
    );
  }
}

export default Tour;
